import React, { Component } from "react";
import PropTypes from "prop-types";

import Loader from "./Loader";
import "./Image.scss";

const loadImagePromise = imageUrl =>
  new Promise((resolve, reject) => {
    const img = new window.Image();
    img.src = imageUrl;
    img.onload = () => resolve(img);
    img.onerror = reject;
  });

class Image extends Component {
  static propTypes = {
    src: PropTypes.string.isRequired,
    height: PropTypes.number,
    width: PropTypes.number,
    alt: PropTypes.string,
    // eslint-disable-next-line react/forbid-prop-types
    err: PropTypes.any,
    // eslint-disable-next-line react/forbid-prop-types
    children: PropTypes.any
  };

  static defaultProps = {
    children: null,
    height: null,
    width: null,
    err: null,
    alt: ""
  };

  state = {
    img: null
  };

  componentWillMount() {
    if (this.props.src) {
      this._promise = this.loadImage(this.props.src);
    }
  }

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillReceiveProps(props) {
    if (props.src && props.src !== this.props.src) {
      this.loadImage(props.src);
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  loadImage = imageUrl =>
    loadImagePromise(imageUrl)
      .then(img => (this._isMounted ? this.setState({ img, err: null }) : null))
      .catch(err => (this._isMounted ? this.setState({ img: null, err }) : null));

  render() {
    if (this.state.err) {
      return (
        <div
          className="Image d-flex justify-content-center align-items-center alert alert-danger"
          style={{
            width: this.props.width || this.props.height,
            height: this.props.height || this.props.width
          }}
        >
          Afbeelding kan niet worden ingeladen
        </div>
      );
    }
    if (!this.state.img) {
      return (
        <div
          className="Image d-flex justify-content-center align-items-center"
          style={{
            width: this.props.width || this.props.height,
            height: this.props.height || this.props.width
          }}
        >
          <Loader message="Afbeelding wordt geladen" messagePosition="bottom" />
        </div>
      );
    }
    return (
      <div className="Image">
        <div className="Image_MouseOver" />
        <img alt="" {...this.props} src={this.state.img.src} />
      </div>
    );
  }
}

export default Image;
